import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import { isMultiLayer } from "../../../../../service/oneClickIs"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidImpedance from "../../../../service/visibleValidator/isValidImpedance"

import image from "./impedance.png"

const 特性インピーダンスコントロール = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { impedance: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"特性インピーダンス\nコントロール"}
      helpURL={HELP_LINKS.特性インピーダンスコントロール}
      src={image}
    >
      <RadioGroup
        name={FIELD_NAMES.特性インピーダンスコントロール}
        selectedValue={values.impedance}
        onChange={handlers.radio}
        shouldRender={(value) => isValidImpedance(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.特性インピーダンスコントロール.なし.value}>なし</Radio>
          <Radio value={ESTIMATE_CONSTANT.特性インピーダンスコントロール["差動（2種、最小75Ωまで）"].value}>
            差動{"\n"}（2種、最小75Ωまで）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.特性インピーダンスコントロール["シングルエンド（2種）"].value}>
            シングルエンド{"\n"}（2種）
          </Radio>
          <Radio
            value={
              ESTIMATE_CONSTANT.特性インピーダンスコントロール["シングルエンド（1種）+ 差動（1種、最小75Ωまで）"].value
            }
          >
            シングルエンド{"\n"}（1種）+ 差動（1種、最小75Ωまで）
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.impedance}>
        {!isMultiLayer(values) && <p>※特性インピーダンスコントロールは4層以上での受付となります。</p>}
      </OneClickFieldMessages>
    </OneClickField>
  )
}

export default 特性インピーダンスコントロール
